import { render, staticRenderFns } from "./MoleculeEditionAcademyInvitationsModalData.vue?vue&type=template&id=254bbf25&"
import script from "./MoleculeEditionAcademyInvitationsModalData.vue?vue&type=script&lang=js&"
export * from "./MoleculeEditionAcademyInvitationsModalData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports